export const profileConf = [
  {
    name: 'Особисте інфо',
    path: '/profile/user-info',
  },
  { name: 'Заміна пароля', path: '/profile/password-change' },
  // { name: 'Оплата за курс', path: '/profile/payment' },
];
